import styled from "@emotion/styled";
import UI from "@mile-meeting/mile-ui";
import { useRecoilValue } from "recoil";
import { roleToString, stringToRole, UserRole } from "utils/role";
import { member, user, workspace } from "recoil/recoilState";
const MemberItem = ({
  name,
  email,
  role,
  isMe,
  image,
  gwsOrgUnit,
  gwsDomainList,
  onChangeRole,
  onHandleDelete,
}: {
  name: string;
  email: string;
  role: UserRole;
  isMe: boolean;
  image?: string;
  gwsOrgUnit?: string;
  gwsDomainList?: string[];
  onChangeRole?: (role: UserRole) => void;
  onHandleDelete?: () => void;
}) => {
  const memberInfo = useRecoilValue(member);

  const myPermission = memberInfo?.role ?? UserRole.Staff;
  const canEditPermission = myPermission <= UserRole.SuperAdmin && myPermission <= role;
  const permissionList =
    myPermission === UserRole.Owner
      ? ["Owner", "Super Admin", "Policy Admin", "Security Admin", "Staff"]
      : ["Super Admin", "Policy Admin", "Security Admin", "Staff"];

  const getLinkInfo = () => {
    if (gwsOrgUnit) {
      //* 조직 연동
      const link = gwsOrgUnit.split("/");
      const linkInfo = link[link.length - 1];
      return `조직 연동 (${linkInfo})`;
    }
    if (gwsDomainList && gwsDomainList.length > 0) {
      //* 도메인 연동
      const isSynced = gwsDomainList.includes(email.split("@")[1]);
      return isSynced ? "도메인 연동" : "-";
    }

    return "-";
  };
  return (
    <Container>
      <ProfileContainer>
        {image ? <ProfileImage src={image} /> : <EmptyImage />}
        <NameContainer>
          <UI.ToolTip
            type="white"
            text={name}
            styles={{
              textOverflow: "ellipsis",
              overflow: "visible",
            }}
            position={{
              top: "100%",
            }}
          >
            <UI.Typography
              style={{
                textOverflow: "ellipsis",
                overflow: "hidden",
                whiteSpace: "nowrap",
                width: isMe ? "81px" : "131px",
              }}
            >
              {name}
            </UI.Typography>
          </UI.ToolTip>
          {/* TODO: Chip Tag Gray 색상으로 변경해야 함. */}
          {isMe && <UI.Tag label="본인" size="small" color="gray" type="primary" />}
        </NameContainer>
      </ProfileContainer>
      <UI.Typography
        type="label01"
        fontStyle="regular"
        color="var(--alias-color-label-alternative)"
        style={{ marginLeft: "32px", width: "191px" }}
      >
        {email}
      </UI.Typography>
      <UI.Typography
        type="label01"
        fontStyle="regular"
        color="var(--alias-color-label-alternative)"
        style={{
          marginLeft: "32px",
          width: "191px",
          textOverflow: "ellipsis",
          overflow: "hidden",
          whiteSpace: "nowrap",
          alignItems: "center",
          display: "flex",
          gap: "4px",
        }}
      >
        {getLinkInfo() !== "-" && <UI.Icon name="google" size={16} />}
        {getLinkInfo()}
      </UI.Typography>
      {isMe || !canEditPermission ? (
        <UI.Typography
          type="label01"
          fontStyle="regular"
          color="var(--alias-color-label-normal)"
          style={{ width: "191px", marginLeft: "32px" }}
        >
          {roleToString(role)}
        </UI.Typography>
      ) : (
        <>
          <div style={{ width: "191px", marginLeft: "32px" }}>
            <UI.SelectBox
              width={160}
              data={permissionList}
              selectedData={[roleToString(role) ?? ""]}
              value={roleToString(role)}
              size="small"
              dropdownWidth={160}
              onChange={(value: string[]) => {
                onChangeRole?.(stringToRole(value[0]));
              }}
            />
          </div>
          <UI.Button
            type="outlined"
            size="small"
            primary={false}
            title="삭제하기"
            style={{ marginRight: "86px", marginLeft: "auto" }}
            onClick={onHandleDelete}
          />
        </>
      )}
    </Container>
  );
};

export default MemberItem;

const Container = styled.div`
  padding: 8px 24px;
  box-sizing: border-box;
  display: flex;
  border-bottom: solid 1px var(--alias-color-line-normal);
  align-items: center;
`;

const ProfileContainer = styled.div`
  width: 191px;
  display: flex;
  gap: 20px;
  align-items: center;
  height: 100%;
`;

const ProfileImage = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 100px;
  background-color: var(--component-color-fill-normal);
`;

const NameContainer = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  width: 131px;

  p {
    white-space: nowrap;
  }
`;

const EmptyImage = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 100px;
  background-color: var(--component-color-fill-normal);
`;
